module.exports = __webpack_public_path__ + "caret-right-f862bb352ee25139c31a.svg";